export default __webpack_public_path__ + "static/404-bg-1e9489151302f742376fffb0e49154b8.jpg";